export default {
  /*
   * カンマ除去
   */
  removeComma: function (num) {
    if (!num) { return }

    if (window.isFinite(num) === true) {
      return parseFloat(num)
    }
    var removedNum = num.replace(/,/g, '')
    return parseFloat(removedNum)
  }
}
